import { render, staticRenderFns } from "./EventPackageOffer.vue?vue&type=template&id=c8daab9e&"
import script from "./EventPackageOffer.vue?vue&type=script&lang=js&"
export * from "./EventPackageOffer.vue?vue&type=script&lang=js&"
import style0 from "./EventPackageOffer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports